import fetch from '../utils/fetch'

//實體訂單列表/自營訂單列表 （備註）
export function remarks ({ orderId, ...restParams }) {
  return fetch({
    url: `/remarks/${orderId}`,
    method: 'put',
    params: restParams
  })
}

//售後服務列表新增備註功能
export function afterRemarks (params) {
  return fetch({
    url: `/aftersales/remark`,
    method: 'put',
    params: params
  })
}
